import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../../api/axios";
import AuthTravelShell from "../../components/travel-theme/AuthTravelShell";

const Verify = () => {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const verifyAccount = async () => {
      try {
        await axiosInstance.get(`/api/auth/verify/${token}`);
        setSuccess(true);
      } catch (error) {
        // console.log(error)
        setSuccess(false);
      }
      setLoading(false);
    };

    verifyAccount();
  }, [token]);

  const title = loading
    ? "Checking your ticket."
    : success
      ? "You are cleared."
      : "Ticket not found.";

  return (
    <AuthTravelShell
      eyebrow="HackPrinceton email verification"
      title={title}
      description="We are confirming your boarding pass for HackPrinceton Fall 2026."
      ticketCode={loading ? "CHECK" : success ? "VERIFIED" : "RETRY"}
    >
      <div className="auth-form">
        {loading ? (
          <p className="subtitle" role="status">
            Verifying your email address...
          </p>
        ) : success ? (
          <>
            <p className="subtitle">Your account is ready.</p>
            <a href="/login" className="auth-button-link">
              Continue to login
            </a>
          </>
        ) : (
          <>
            <p className="subtitle">
              This verification link is invalid, expired, or registration is closed.
            </p>
            <p className="subtitle">
              Register again or contact team@hackprinceton.com if the issue continues.
            </p>
            <a href="/register" className="auth-button-link">
              Return to registration
            </a>
          </>
        )}
      </div>
    </AuthTravelShell>
  );
};

export default Verify;
